import OWContainer from 'styles/styled-components/ow-container';
import useController from '../controllers/endUsers-controller';
import { MaterialReactTable } from 'material-react-table';

export const EndUsersRoute = () => {
    const { tableSettings } = useController();

    return (
        <OWContainer>
            <MaterialReactTable table={tableSettings} />
        </OWContainer>
    );
};
